// Client lifecycle stage — the marketing "lead status" funnel shared by the API and the admin web app.
// Mirrors the Prisma `ClientLifecycleStage` enum; kept here so both sides label/colour it identically.
// ---------------------------------------------------------------------------

export const CLIENT_LIFECYCLE_STAGES = ['LEAD', 'BOOKED', 'ACTIVE', 'LAPSED', 'BLOCKED'] as const;
export type ClientLifecycleStage = (typeof CLIENT_LIFECYCLE_STAGES)[number];

/** Everyone past the LEAD stage — the Clients page's "Clients" chip (and the bulk-text "Excluding leads" label). */
export const CLIENT_PAST_LEAD_STAGES: readonly ClientLifecycleStage[] = ['BOOKED', 'ACTIVE', 'LAPSED', 'BLOCKED'];

/** Human labels for the Leads table stage pill (matches the pipeline mockup). */
export const CLIENT_LIFECYCLE_STAGE_LABELS: Record<ClientLifecycleStage, string> = {
  LEAD: 'Lead',
  BOOKED: 'Booked',
  ACTIVE: 'Active client',
  LAPSED: 'Lapsed',
  BLOCKED: 'Blocked',
};

/** Marketing consent, as shown in the Leads table. `STOP` is opt-out via inbound keyword. */
export const LEAD_CONSENT_STATES = ['opted_in', 'opted_out'] as const;
export type LeadConsentState = (typeof LEAD_CONSENT_STATES)[number];

/** Whether the sign-up created a brand-new client or attached to an existing one. */
export const LEAD_ORIGINS = ['NEW', 'RETURNING'] as const;
export type LeadOrigin = (typeof LEAD_ORIGINS)[number];
